import ResetPasswordForm from '../components/ResetPasswordForm';

export default function ResetPasswordPage() {
  return <ResetPasswordForm />;
}
